
import { Component, Vue } from 'vue-property-decorator';


@Component
export default class rspToAppealInstructions extends Vue {  
    
    selfRep = false;
    dataReady = false;

    mounted() {
        this.dataReady = false;
        this.selfRep = this.$store.state.Common.userSelfRepresented;
        this.dataReady = true;
	}

}

